import { EventEmitter } from "events"

const eventManager = new EventEmitter()

export default eventManager
